import { useUnit } from 'effector-react'
import { MenuItem, MenuSection, Separator } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { $portalProfile } from '@/entities/profile/portal'
import { ClientRuntimeToggle } from '@/features/client-runtime-toggle'
import { SupportIDButtonNavbarPlay } from '@/features/copy-support-id-button'
import { env } from '@/shared/config'
import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'

import {
    BuildVersionInfo,
    ChatButton,
    ClientVersionInfo,
    DeployVersionInfo,
    KnowledgeLink,
    LangButton,
    LegalLinks,
    LogoutButton,
    NewsButton,
    SupportContactButton,
} from '../ui'
import { DropdownMenu } from '../ui/dropdown-menu'
import { navbar, navbarMenu } from '../ui/styles/recipe'

export function NavbarPlay() {
    const classes = navbar()

    return (
        <div className={classes.root}>
            <div className={css({ display: 'flex', alignItems: 'center' })}>
                <div>
                    <img
                        src={getAssetUrl('/assets/taongaSwirl.svg')}
                        height="28"
                        width="28"
                        alt=""
                        className={css({ margin: 'auto' })}
                        draggable="false"
                    />
                </div>
                <ul className={cx(classes.list, css({ marginLeft: '2' }))}>
                    <NavMenuDropdown />

                    <NewsButton />
                    <SupportContactButton />
                    <KnowledgeLink />
                </ul>
            </div>

            <ul className={cx(classes.list, css({ marginRight: '1' }))}>
                <DeployVersionInfo className={css({ display: { base: 'none', lg: 'block' } })} />
                <ClientRuntimeToggle className={css({ display: { base: 'none', lg: 'block' } })} />
                <ClientVersionInfo className={css({ display: { base: 'none', lg: 'block' } })} />
                <BuildVersionInfo className={css({ display: { base: 'none', lg: 'block' } })} />
                <SupportIDButtonNavbarPlay variant="navbar" />
                <ChatButton />
            </ul>
        </div>
    )
}

function NavMenuDropdown() {
    const { i18n, lang } = useI18n()
    const classes = navbarMenu()

    const profile = useUnit($portalProfile)

    return (
        <li>
            <DropdownMenu>
                <MenuItem isDisabled>
                    <div
                        className={css({
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        })}
                    >
                        <div className={css({ padding: '1' })}>
                            <img
                                className={css({ width: '6', height: '6', borderRadius: '[50%]', margin: 'auto' })}
                                src={profile?.imageURL || getAssetUrl('/assets/avatar/defaultAvatar.png')}
                                alt="avatar"
                            />
                        </div>
                        <div
                            id="navbar_account_name"
                            className={css({
                                maxWidth: '[15rem]',
                                padding: '1',
                                textAlign: 'center',
                                lineHeight: 'tight',
                                overflowWrap: 'break-word',
                            })}
                        >
                            {profile?.nick || i18n.PLACEHOLDER_USERNAME}
                        </div>
                    </div>
                </MenuItem>

                <Separator className={classes.separator} />

                <MenuItem className={classes.itemNav} href={`/${lang}/account/`}>
                    <i className={cx('fa-solid fa-user', classes.icon)} />
                    &nbsp;{i18n.PORTAL_PROFILE}
                </MenuItem>

                {/* показывается только на md экранах и меньше */}
                <MenuSection className={css({ width: 'full', display: { lg: 'none' } })}>
                    <SupportIDButtonNavbarPlay variant="dropdown" className={classes.itemNav} />
                </MenuSection>

                <LangButton variant="dropdown" />

                <Separator className={classes.separator} />

                {/* Схлопнутая портальная навигация - показывается только на md экранах и меньше */}
                <MenuSection className={css({ width: 'full', display: { lg: 'none' } })}>
                    <NewsButton variant="dropdown" />
                    <SupportContactButton variant="dropdown" />
                    <KnowledgeLink variant="dropdown" />
                    <Separator className={classes.separator} />
                    {profile?.tester && (
                        <MenuItem className={css({ paddingX: '4', fontSize: '[14px]' })} isDisabled>
                            {env.BUILD_VERSION}
                        </MenuItem>
                    )}
                </MenuSection>

                <LegalLinks />
                <Separator className={classes.separator} />
                <LogoutButton />
            </DropdownMenu>
        </li>
    )
}
